var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img--magnify",on:{"click":_vm.emitClicked}},[_c('font-awesome-icon',{staticClass:"magnify-icon",attrs:{"icon":"search-plus","size":"lg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }